/**
 * 模考证据列表：权威来源是 server AbilitySnapshot source=mock。
 * Dexie examRecords / exams.history 不是诊断页真相。
 */

import { useCallback, useEffect, useState } from 'react';
import {
  buildMockExamEvidenceRecordsFromAbilitySnapshots,
  type MockExamEvidenceRecord,
} from '@examflow/learning-space';
import { api } from '../../lib/api';

export type RecentMockExamRecordsStatus = 'loading' | 'ready' | 'unavailable';

export function useRecentMockExamRecords({
  userId,
  examType,
  limit = 3,
  refreshKey,
}: {
  userId?: string | null;
  examType?: string | null;
  /** @deprecated 模考证据按 examType 拉取快照；保留参数以免破坏调用方 */
  languageId?: string | null;
  limit?: number;
  refreshKey?: number | string;
}) {
  const [records, setRecords] = useState<MockExamEvidenceRecord[]>([]);
  const [status, setStatus] = useState<RecentMockExamRecordsStatus>('loading');

  const loadRecords = useCallback(async () => {
    if (!userId || !examType) {
      setRecords([]);
      setStatus('unavailable');
      return;
    }

    setStatus('loading');

    try {
      const { snapshots } = await api.learning.getAbilitySnapshots({
        examType,
        limit: Math.max(limit * 4, 20),
      });
      setRecords(
        buildMockExamEvidenceRecordsFromAbilitySnapshots(snapshots, { limit })
      );
      setStatus('ready');
    } catch {
      setRecords([]);
      setStatus('unavailable');
    }
  }, [userId, examType, limit]);

  useEffect(() => {
    void loadRecords();
  }, [loadRecords, refreshKey]);

  return {
    records,
    status,
    reload: loadRecords,
  };
}
